export default "__VITE_ASSET__B6hqW9KS__"